import { Base } from '@studiometa/js-toolkit';
import anime from 'animejs';

/**
 * @typedef {Object} HeaderRefs
 * @property {HTMLElement} toggle
 * @property {HTMLElement} menu
 */

/**
 * @typedef {Object} HeaderInterface
 * @property {HeaderRefs} $refs
 * @property {Boolean} active
 * @property {HTMLElement[]} links
 * @property {HTMLElement} contactInformations
 * @property {HTMLElement} mobileCTA
 */

/**
 * Homepage class.
 */
export default class Header extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'Header',
    refs: ['toggle', 'menu'],
  };

  /**
   * Initialize the component's behavior.
   *
   * @this {Header & HeaderInterface}
   */
  mounted() {
    this.active = false;
    this.links = this.$refs.menu.querySelectorAll('li a');
    this.contactInformations = this.$refs.menu.querySelector('.contact-informations');
    this.mobileCTA = this.$refs.menu.querySelector('.header__cta-mobile');
  }

  /**
   * On toggle click.
   *
   * @this {Header & HeaderInterface}
   */
  onToggleClick() {
    this.active = !this.active;

    if (this.active) {
      document.body.style.overflow = 'hidden';

      this.$el.classList.add('active');
      this.$refs.menu.classList.add('active');

      anime({
        targets: this.$refs.menu,
        opacity: 1,
        easing: 'linear',
        duration: 200,
      });

      anime({
        targets: [this.contactInformations, this.mobileCTA],
        opacity: [0, 1],
        duration: 500,
        easing: 'linear',
        delay: 350,
      });

      this.links.forEach((link, index) => {
        anime({
          targets: link,
          translateY: ['150%', '0%'],
          opacity: [0, 1],
          easing: 'easeOutQuart',
          duration: 800 + 80 * (6 - index),
          delay: 80 * index,
        });
      });
    } else {
      document.body.style.overflow = '';

      this.$el.classList.remove('active');
      this.$refs.menu.classList.remove('active');

      anime({
        targets: this.$refs.menu,
        opacity: 0,
        easing: 'linear',
        duration: 200,
      });
    }
  }
}
